var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import { colors } from '../../../abstracts/colors';
import { getFontSize, getFontWeight } from '../../../abstracts/typography';
import { createTransition } from '../../../util';
var successState = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), colors.successDeeper);
var warnState = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), colors.black);
var errorState = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), colors.errorDeep);
var defaultState = css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), colors.neutralDeeper);
var helperTextStateToCss = {
    success: successState,
    warn: warnState,
    error: errorState,
    "default": defaultState
};
export var TextFieldHelperText = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: 130%;\n  -moz-osx-font-smoothing: grayscale;\n  font-weight: ", ";\n  padding: 0.25rem 0.75rem;\n  background-color: transparent;\n\n  ", ";\n\n  ", ";\n"], ["\n  font-size: ", ";\n  line-height: 130%;\n  -moz-osx-font-smoothing: grayscale;\n  font-weight: ", ";\n  padding: 0.25rem 0.75rem;\n  background-color: transparent;\n\n  ", ";\n\n  ", ";\n"])), getFontSize(1), getFontWeight('base'), function (_a) {
    var fieldStatus = _a.fieldStatus;
    return helperTextStateToCss[fieldStatus];
}, createTransition({ properties: ['color'] }));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
